import { createAction, props } from '@ngrx/store';
import { User } from '../../interfaces/interfaces.interface';

export interface UserState {
    data: User | null;
    loading?: boolean;
}

export const setUser = createAction(
    '[User] Usuario cargado',
    props<UserState>()
);
export const updateUser = createAction('[User] Usuario actualizado');